
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Booking, {
  TableAssignmentStatus
} from "../../../domain/booking/Booking";
import BookingViewDatePicker from "@/components/booking/components/BookingViewDatePicker.vue";
import BookingAvailableTimes from "./BookingAvailableTimes.vue";
import WorkingHours from "@/domain/restaurant/WorkingHours";
import { VuetifyForm } from "@/plugins/vuetify";
import Room from "@/domain/restaurant/Room";
import TablePicker from "@/components/booking/components/TablePicker.vue";
import Restaurant from "@/domain/restaurant/Restaurant";

@Component({
  components: {
    TablePicker,
    BookingAvailableTimes,
    BookingViewDatePicker
  }
})
export default class BookingPropertiesPicker extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({ default: () => new Booking() })
  booking!: Booking;

  @Prop({ default: () => new Date() })
  selectedDate!: Date;

  @Prop({ default: () => null })
  selectedRoom!: Room | null;

  @Prop({ default: "" })
  selectedTime!: string;

  @Prop({ default: false })
  showTimePicker!: boolean;

  selectedWorkingHours: WorkingHours | null = null;

  canGetAvailableTimes = false;

  @Prop({ default: null })
  tableAssignmentStatus!: TableAssignmentStatus | null;

  get workingHoursStartTime(): string {
    if (this.selectedWorkingHours != null)
      return this.selectedWorkingHours.startTime;
    return "00:00";
  }

  get workingHoursEndTime(): string {
    if (this.selectedWorkingHours != null)
      return this.selectedWorkingHours.endTime;
    return "23:59";
  }

  allowedMinutes(m: number) {
    if (this.selectedRestaurant != null)
      return m % this.selectedRestaurant.bookingInterval === 0;
    return m % 5 === 0;
  }

  get selectedRestaurant(): Restaurant | null {
    return this.$store.getters.getSelectedRestaurant;
  }

  roomOpenColour(room: Room | null): string {
    if (room == null || Room.isOpenOnDate(room, this.selectedDate)) return "";
    return "red";
  }

  reasonRoomIsClosed(room: Room | null): string {
    if (room == null) return "";
    return Room.getReasonIsClosedOnDate(room, this.selectedDate);
  }

  selectRequestedTable(newRequestedTableId: number | null) {
    this.selectedTableId(newRequestedTableId);
    this.isFormValid = this.isValid();
  }

  cancelTableSelection() {
    this.showTablePicker = false;
    // this.selectRequestedTable(null);
  }

  get tableAssignmentIcon() {
    if (
      this.tableAssignmentStatus != null &&
      this.tableAssignmentStatus.icon != null
    )
      return this.tableAssignmentStatus.icon;
    return { icon: "", colour: "" };
  }

  get showTablePicker() {
    if (this.tableAssignmentStatus != null) {
      this.isFormValid = this.isValid();
      return this.tableAssignmentStatus.tableChoice;
    }
    return false;
  }

  set showTablePicker(newVal: boolean) {
    this.$emit("clear-table-assignment-status", null);
  }

  selectedTableId(newVal: number | null) {
    this.$emit("selected-table-id", newVal);
  }

  @Watch("selectedRoom")
  onRoomChange() {
    if (this.selectedRoom !== null) {
      this.cancelTableSelection();
    }
  }

  mounted() {
    if (this.possibleWorkingHours.length === 1)
      this.selectedWorkingHours = this.possibleWorkingHours[0];
  }

  get timePickerProp() {
    return this.showTimePicker;
  }

  set timePickerProp(newVal: boolean) {
    this.$emit("time-picker", newVal);
  }

  get isFormValid() {
    return this.value;
  }

  set isFormValid(newVal: boolean) {
    this.$emit("input", this.isValid());
  }

  isValid(): boolean {
    // this.form.validate();
    return (
      this.booking.numberOfPeople != null &&
      this.selectedTime != null &&
      this.selectedTime !== "" &&
      this.booking.preferredRoomId !== undefined &&
      (this.tableAssignmentStatus == null ||
        !this.tableAssignmentStatus.tableChoice ||
        (this.tableAssignmentStatus.tableChoice &&
          this.booking.tableId != null))
    );
  }

  get availableTimesSelect() {
    return this.$refs.AvailableTimes as BookingAvailableTimes;
  }

  getAvailableTimes() {
    this.availableTimesSelect.getAvailableTimes();
  }

  get form() {
    return this.$refs.BookingForm as VuetifyForm;
  }

  public async validate() {
    await this.form.validate();
    this.isFormValid = this.isValid();
  }

  get possibleWorkingHours() {
    return this.$store.getters.getSelectedRestaurant.workingHours;
  }

  get possibleRooms() {
    return this.$store.getters.getSelectedRestaurant.rooms;
  }

  set updateTime(newTime: string) {
    this.emitNewTime(newTime);
    this.validate();
  }

  get preferredRoom() {
    if (this.selectedRoom != null) return this.selectedRoom;
    return new Room();
  }

  set preferredRoom(room: Room) {
    this.booking.preferredRoomId = room != null ? room.roomId : undefined;
    this.$emit("update-room", room);
  }

  emitNewTime(newTime: string) {
    this.$emit("update-time", newTime);
    this.validate();
  }

  get updateTime() {
    return this.selectedTime;
  }

  updateDate(newDate: Date) {
    this.$emit("update-date", newDate);
    this.validate();
  }

  get possibleNumberOfPeopleValues() {
    const toReturn = Array.from(Array(Booking.MAX_NUMBER_OF_PEOPLE).keys());
    toReturn.splice(0, 1);
    return toReturn;
  }
}
